import { FC } from "react";

export interface ColorSwatchDiscountBadgeProps {
  discountPercentage: number;
}

export const ColorSwatchDiscountBadge: FC<ColorSwatchDiscountBadgeProps> = ({
  discountPercentage,
}): JSX.Element | null => {
  if (discountPercentage <= 0) {
    return null;
  }

  const percentage = Math.round(discountPercentage * 100);

  return (
    <div className="absolute top-1 right-1 bg-[#FFFFFFCC] px-3 py-0.5 rounded-md">
      <span className="font-bold text-xs leading-none text-[#393B42]">
        -{percentage} %
      </span>
    </div>
  );
};
